import 'react-app-polyfill/ie11';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import ScrollToTop from './ScrollToTop';
import i18n from './i18n';
import { AbilityContext } from 'configs/CASLContext';
import ability from 'configs/Ability';
import AuthenticationProvider from 'providers/AuthenticationProvider';

//import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <AuthenticationProvider>
        <AbilityContext.Provider value={ability}>
            <Suspense fallback="loading">
                <I18nextProvider i18n={i18n}>
                    <HashRouter>
                        <ScrollToTop>
                            <App />
                        </ScrollToTop>
                    </HashRouter>
                </I18nextProvider>
            </Suspense>
        </AbilityContext.Provider>
        ,
    </AuthenticationProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
